import { Content, Header, Page } from '@backstage/core-components';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import {
  HomePageStarredEntities,
  HomePageToolkit,
} from '@backstage/plugin-home';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import { Grid } from '@material-ui/core';
import StorageIcon from '@material-ui/icons/Storage';
import ListAltIcon from '@material-ui/icons/ListAlt';
import AirflowIcon from '@material-ui/icons/Toys';

export const HomePage = () => {
  const configApi = useApi(configApiRef);
  // Airflow URL 은 사이드바(Root.tsx)와 같은 config 값을 쓴다
  const airflowDevUrl = configApi.getOptionalString('app.airflowDevUrl');
  const airflowProdUrl = configApi.getOptionalString('app.airflowProdUrl');

  const tools = [
    { label: 'Data Hub', url: '/data-hub', icon: <StorageIcon /> },
    { label: 'Registry', url: '/registry', icon: <ListAltIcon /> },
    ...(airflowDevUrl
      ? [{ label: 'Airflow DEV', url: airflowDevUrl, icon: <AirflowIcon /> }]
      : []),
    ...(airflowProdUrl
      ? [{ label: 'Airflow PROD', url: airflowProdUrl, icon: <AirflowIcon /> }]
      : []),
  ];

  return (
    <SearchContextProvider>
      <Page themeId="home">
        <Header title="Home" />
        <Content>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <HomePageSearchBar placeholder="Search" />
            </Grid>
            <Grid item xs={12} md={6}>
              <HomePageStarredEntities />
            </Grid>
            <Grid item xs={12} md={6}>
              <HomePageToolkit tools={tools} />
            </Grid>
          </Grid>
        </Content>
      </Page>
    </SearchContextProvider>
  );
};
